import React from "react";
import PropTypes from "prop-types";
import { isFieldQuestionVisible } from "../../../shared/informationRequest/fieldVisibility";
import UploadedFileList from "../../../components/UploadedFileList";
import Link from "../../../components/Link";
import styled from "styled-components/macro";
import { CheckBox } from "@styled-icons/material-outlined";
import { getCountryName } from "../../../utils/countryRiskUtils";
import { formatMoneyWithCurrency, isMoneyValid, normaliseMoney } from "../../../shared/utils/moneyUtils";

const formatResponse = (config, response, uploads) => {
  const fieldType = config.field_type;

  switch (fieldType) {
    case "document_upload":
      return <UploadedFileList uploads={uploads} />;
    case "boolean":
      if (response == null) {
        return null;
      } else if (response === "false" || response === false) {
        return "No";
      } else {
        return "Yes";
      }
    case "radio":
      return config.choices.find((choice) => choice.value === response)?.label ?? null;
    case "checkbox":
      const checkedResponses = [];
      if (response instanceof Object) {
        for (const [key, value] of Object.entries(response)) {
          if (value === true) {
            const option = config.choices.filter((choice) => choice.value === key);
            checkedResponses.push(option[0].label);
          }
        }
      }
      return checkedResponses.map((item, index) => (
        <CheckBoxResponse key={index}>
          <CheckBoxResponseIcon /> {item}
        </CheckBoxResponse>
      ));
    case "confirmation":
      if (response === true) {
        return (
          <CheckBoxResponse>
            <CheckBoxResponseIcon /> I confirm
          </CheckBoxResponse>
        );
      }
      return null;
    case "date":
    case "must_happen_by_date":
    case "date_in_the_past":
      if (response === null) {
        return null;
      }
      return `${response.day}/${response.month}/${response.year}`;
    case "money":
      if (!isMoneyValid(response)) {
        return response || null;
      }
      return formatMoneyWithCurrency(parseFloat(normaliseMoney(response)));
    case "country":
      if (response === null || response === "") {
        return null;
      }
      // Convert Alpha-3 code to human-readable country name
      return getCountryName(response) || response;
    default:
      // Objects are not valid as a react child
      if (response instanceof Object) {
        return null;
      }
      if (typeof response === "string") {
        return response;
      }
  }
};

const ReviewQuestion = (props) => {
  if (!isFieldQuestionVisible(props.doableConfig, props.fieldConfig, props.responses)) {
    return null;
  }

  const question = props.fieldConfig.display_name;
  const fieldIdentifier = props.fieldConfig.field_identifier;

  return (
    <tr>
      <td>{question}</td>
      <td>{formatResponse(props.fieldConfig, props.responseToQuestion, props.uploads)}</td>
      <td>
        <Link onClick={() => props.showPrevious(fieldIdentifier)}>Change</Link>
      </td>
    </tr>
  );
};

ReviewQuestion.propTypes = {
  doableConfig: PropTypes.object.isRequired,
  fieldConfig: PropTypes.object.isRequired,
  responses: PropTypes.object.isRequired,
  responseToQuestion: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object]),
  uploads: PropTypes.arrayOf(
    PropTypes.shape({
      upload_id: PropTypes.string.isRequired,
      filename: PropTypes.string.isRequired,
    }),
  ),
  showPrevious: PropTypes.func.isRequired,
};

export const CheckBoxResponse = styled.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
`;

export const CheckBoxResponseIcon = styled(CheckBox)`
  color: var(--juno-color-light-grey);
  width: var(--juno-icon-size-sm);
  margin-right: 6px;
`;

export default ReviewQuestion;
